import { ITableClasses } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/styledTable/StyledTable'

import { Row } from './Row'
import { IColumn } from './types'

//import styles from './StyledTable.module.scss'

interface IProps<T> {
  columns: IColumn<T>[]
  items: T[]
  deleteRow?: (index: number) => void
  keyField?: string
  classes: ITableClasses
}

export function Rows<T>({ columns, items, deleteRow, keyField, classes }: IProps<T>) {
  return (
    <>
      {(items || []).map((item: any, key: number) => {
        return (
          <Row<T>
            key={key}
            item={item}
            columns={columns}
            rowIndex={key}
            deleteRow={deleteRow}
            keyField={keyField}
            classes={classes}
          />
        )
      })}
    </>
  )
}
